import { Div, CollectionView, Snack, Span, Line } from "@tblabs/truffle";
import { StepsOrganizer } from "./StepsOrganizer";
import { Bag } from "./Bag";
import { AdminStepPrinter } from "../../../../../Components/AdminStepPrinter";
import { Center } from "../../../../../Components/Utils/Center";
import { Order } from "../../../../../Models/Order";
import { Router } from "../../../../../Services/Router";
import { StepsMarker } from "../../../../../Services/StepsMarker";
import { OrdersManager } from "../../../../../Services/OrdersManager";
import { AgentsProvider } from "../../../../../Services/AgentsProvider";
import { MarkedStep } from "../../../../../Models/MarkedStep";


export class BagBox extends Div
{
    constructor(bag: Bag<MarkedStep>, _router: Router, _agents: AgentsProvider)
    {
        super();

        this.Append(
            new Div("bag-header").Text(bag.Title)
                .Append(new Span(bag.Size.toString()).Class("items-in-bag-count")),

            new Div("blocks-container").Append(
                ...bag.Items.map(step => new AdminStepPrinter(_router, _agents, step))
            ),

            bag.Size == 0 && new Center(`Brak zadań`).Italic().Color("#ccc")
        )
    }

}

export class TodoView extends Div
{
    constructor(_router: Router, _manager: OrdersManager, _agents: AgentsProvider, orders: CollectionView<Order>)
    {
        super("TodoView");

        const stepsOrganizer = new StepsOrganizer();

        orders.Items.forEach(order =>
        {
            order.OnChange(async () =>
            {
                await _manager.Update(order);
                new Snack(`Zamówienie #${order.ShortId} zaktualizowane`);
            });

            const steps = order.Steps.Items;
            const markedSteps = StepsMarker.Mark(steps);
            const currentStep = markedSteps.find(x => x.IsCurrent);

            if (currentStep)
                stepsOrganizer.PutToBag(currentStep);
        });

        // stepsOrganizer.BagsNames.map(bag =>
        //     this.Append(
        //         new Div("bag-header").Text(stepsOrganizer.BagsTitles[bag])
        //             .Append(new Span(stepsOrganizer.bags[bag].length.toString()).Class("items-in-bag-count")),
        //         new Div("blocks-container").Append(
        //             ...stepsOrganizer.bags[bag].map(step => new AdminStepPrinter(_router, _agents, step))
        //         ),
        //         stepsOrganizer.bags[bag].length == 0 && new Center(`Brak zadań ${stepsOrganizer.BagsTitles[bag].toLowerCase()}`).Italic().Color("#aaa")
        //     )
        // );
        this.Append(
            ...stepsOrganizer.Bags.map(bag => new BagBox(bag, _router, _agents))
        )
    }
}
